module.exports = __webpack_public_path__ + "img/phone_mock_up_shadow.a5f02913.png";